<script>
  import { onMount } from 'svelte';

  export let googleApiLoad;
  export let radius;
  export let center;

  let map;
  let mapElement;
  let circle;
  let marker;
  let zoom = 10;

  onMount(() => {
    googleApiLoad(init);
  });

  const init = () => {
    const { maps } = window.google;

    map = new maps.Map(mapElement, {
      zoom,
      center,
      disableDefaultUI: true,
    });

    marker = new maps.Marker({
      position: center,
      radius,
      map,
    });

    circle = new maps.Circle({
      strokeColor: '#0094FF',
      strokeOpacity: 0.2,
      strokeWeight: 2,
      fillColor: '#0094FF',
      fillOpacity: 0.2,
      center,
      map,
      radius: radius * 1000,
    });
  };

  $: {
    circle && circle.setRadius(radius * 1000);
  }

  $: {
    circle && circle.setCenter(center);
    map && map.setCenter(center);
    marker && marker.setPosition(center);
  }
</script>

<div class="map" bind:this={mapElement} />

<style>
  .map {
    height: 100%;
  }

  :global(.gmnoprint a, .gmnoprint span, .gm-style-cc) {
    display: none;
  }

  :global(.gmnoprint div) {
    background: none !important;
  }

  :global(
        a[href^="http://maps.google.com/maps"],
        a[href^="https://maps.google.com/maps"]
    ) {
    display: none !important;
  }
</style>
